import { FundTransferState } from './types';

const defaultState: FundTransferState = {
  currencies: [],
  chargingMethods: [],
  countries: [],
  isLoadingCurrencies: false,
  isLoadingCountries: false,
  isLoadingChargingMethods: false,
};
export { defaultState };
